import React from "react"
import Router from "next/router"
import { inject, observer } from "mobx-react"
import styled from "styled-components"
import ReactModal from "react-modal"

import TRACKING from '~/services/tracking'

import MODAL_STYLES from "~/components/modals/styles"
import FixedCloseButton from "~/components/modals/FixedCloseButton"
import NotThereYetModal from "~/components/traffic-tickets/steps/StateSelector/NotThereYetModal"
import StatesDropdown from "~/components/traffic-tickets/steps/StateSelector/StatesDropdown"
import Spacer from "~/components/Spacer"
import WinItButton from "~/components/WinItButton"
import FeaturedIn from "~/components/dashboard/Layout/Footer/logos/FeaturedInLogo"
import Carousel from "~/components/traffic-tickets/Carousel/Slick"
import orangeShield from '~/public/static/images/svg/orangeShield.svg'
import SupportPhoneNumber from "~/components/altHeaders/SupportPhoneNumber"
import PHONE_NUMBERS from "~/components/altHeaders/phoneNumbers"
import DesktopContainer from "~/components/traffic-tickets/DesktopContainer"

const MainContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${props => props.theme.media.smallDesktop`
    overflow: hidden;
  `}
  ${props => props.theme.media.tablet`
    overflow: hidden;
  `}
`

const Layout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
`

const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  ${props => props.theme.media.mobile`
    width: 100%;
    margin-left: 0;
  `}
`

const FormWrapper = styled.form`
  border-radius: 5px;
  background: #FFFFFF;
  box-shadow: 0px 9px 24px rgba(35,41,48,0.15);
  position: relative;
  display: flex;
  width: 65%;
  min-width: 450px;
  ${props => props.theme.media.mobile`
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 6px;
    border-radius: 10px;
    min-width: initial;
  `};
`

const InputWrapper = styled.div`
  border-radius: 5px;
  position: relative;
  width: 65%;
  display: flex;
  align-items: center;
  ${props => props.theme.media.mobile`
    width: 100%;
    margin-left: 0;
  `}
`

const Titles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Title = styled.h1`
  font-size: 65px;
  ${props => props.theme.media.tablet`
    font-size: 40px;
  `}

  text-align: center;
  font-family: ${props => props.theme.fonts.avenirNextHeavy};
  color: #3D3C3C;
  margin: 0;
`

const Subtitle = styled.p`
  font-size: 40px;
  color: #3D3C3C;
  margin: 0;
  ${props => props.theme.media.mobile`
    font-size: 20px;
  `}
`

const RecentlySavedContainer = styled.div`
  width: 100%;
  position: relative;
  ${props => props.theme.media.smallDesktop`
    width: 150%;
  `}
  ${props => props.theme.media.tablet`
    width: 200%;
  `}
  ${props => props.theme.media.mobile`
    width: 250%;
  `}
`

const Smaller = styled.span`
  font-size: 0.65em;
  vertical-align: text-top;
`

const FeaturedInContainer = styled.div`
  display: flex;
  justify-content: center;
  ${props => props.theme.media.smallDesktop`
    width: 100%;
    padding: none;
  `}
`

const ShieldText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: 16px;
  margin-left: 13px;
`

const Shield = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
`

const PhoneNumberContainer = styled.div`
  position: absolute;
  right: 8px;
  top: 12px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 5px 5px #cccccc;
  padding: 10px 15px;
  ${props => props.theme.media.smallDesktop`
    display: none;
  `}
`

const TitleSpacer = styled.div`
  transition: all 0.5s ease;
  height: 70px;
  ${props => props.theme.media.smallDesktop`
  height: 37px;
  `}
  ${props => props.theme.media.mobile`
  height: 24px;
  `}
`

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  selectedState: all.store.trafficSubmission.selectedState,
  trafficSubmission: all.store.trafficSubmission,
}))
@observer
class SearchContainer extends React.Component {
  constructor() {
    super()
    this.state = {
      showModal: false,
    }
  }

  componentDidMount() {
    TRACKING.traffic.stateSelector()
  }

  componentDidUpdate() {
    if (!this.props.selectedState.available && !this.props.selectedState.isPQFlowEnabled && !this.state.showModal) {
      this.openModal()
    }
  }

  openModal = () => this.setState({ showModal: true })

  hideModal = () => {
    this.setState({ showModal: false })
    this.props.trafficSubmission.setSelectedState({ value: "NY" })
  }

  handleSubmit = e => {
    if (e && e.preventDefault) e.preventDefault()
    Router.push(this.props.trafficSubmission.getPathNameFlow())
  }

  render() {
    const { isMobile, selectedState} = this.props
    return (
      <MainContainer>
        <ReactModal
          closeTimeoutMS={300}
          isOpen={this.state.showModal}
          style={
              isMobile
                ? MODAL_STYLES.mobile.general
                : MODAL_STYLES.desktop.general
            }
          contentLabel="WinIt is not in your state yet."
          onRequestClose={this.hideModal}
        >
          <FixedCloseButton
            color={isMobile ? "black" : "white"}
            onClick={this.hideModal}
          />
          <NotThereYetModal hideModal={this.hideModal} />
        </ReactModal>
        <DesktopContainer>
          <Layout>
            <PhoneNumberContainer>
              <SupportPhoneNumber phoneNumber={PHONE_NUMBERS.TRAFFIC_FLOW[selectedState.shortName] || PHONE_NUMBERS.DEFAULT} />
            </PhoneNumberContainer>
            <TitleSpacer />
            <Titles>
              <Title>
                {isMobile ? (
                  <>
                    Fight your traffic tickets
                  </>
                  ) : (
                    <>
                      FIGHT YOUR<br />TRAFFIC TICKETS
                    </>
                  )}
              </Title>
              <Spacer mobile={6} desktop={27} />
            </Titles>
            <Spacer mobile={14} desktop={50} />
            <FormWrapper onSubmit={this.handleSubmit}>
              <StatesDropdown
                noBorder
                controlLabel={isMobile ? null : "Where did you get your traffic ticket?"}
                noIcon
                placeholder=""
              />
              <ButtonWrapper>
                <WinItButton
                  height={isMobile ? 55 : 70}
                  width={isMobile ? '100%' : '150%'}
                  fontSize="18px"
                  onClick={this.handleSubmit}
                  color={isMobile ? "blue" : "green"}
                  shape={isMobile ? "roundSquare" : "square"}
                >
                  {isMobile ? "Fight your ticket" : "GET STARTED NOW"}
                </WinItButton>
              </ButtonWrapper>
            </FormWrapper>
            <Spacer desktop={65} mobile={30} />
            <FeaturedInContainer>
              <FeaturedIn isMobile={this.props.isMobile} homepage />
            </FeaturedInContainer>
          </Layout>
        </DesktopContainer>
      </MainContainer>
    )
  }
}

export default SearchContainer
